/**
 * zone.js event-patching config — MUST be imported BEFORE `zone.js` in main.ts.
 * (ES module imports run in source order, so this file's side effect executes
 * before zone.js initialises its EventTarget patch and reads these globals.)
 *
 * THE BUG: Mapbox GL registers its scroll-zoom / pan handlers on `wheel` and
 * calls preventDefault() inside them. zone.js monkeypatches addEventListener
 * GLOBALLY (on the prototype), so wrapping mapbox's wheel listener lets Chrome's
 * passive-by-default intervention make it passive — mapbox's preventDefault()
 * then fails and floods the console with "Unable to preventDefault inside passive
 * event listener" on every trackpad pan/zoom. Constructing the map outside the
 * Angular zone does NOT help: the patch is global, not zone-scoped.
 *
 * THE FIX: listing these events in __zone_symbol__UNPATCHED_EVENTS makes zone.js
 * skip its wrapper (zone.js:1182-1191) and call the NATIVE addEventListener with
 * mapbox's original options ({ passive: false }) intact, so preventDefault works.
 * Unpatched events bypass Angular change detection — fine here: the app is
 * signal-driven, and the only other `wheel` listeners already drive CD via an
 * explicit zone.run() (schedule zoom) or are preventDefault-only
 * (availability-grid scroll containment).
 *
 * mousemove + touchmove are ALSO unpatched: Mapbox attaches WINDOW-level
 * mousemoveWindow / touchmove drag handlers that call preventDefault, flooding
 * the console with "Unable to preventDefault inside passive event listener" on
 * every map drag/pan. Unpatching is safe in this signal-driven app: the only
 * window-level drag handlers (paper-side-drawer, paper-resizable-panel) update
 * SIGNALS (e.g. width.set), and the schedule grid's (mousemove) bindings tick via
 * Angular's signal/scheduler change detection — both fire CD WITHOUT relying on
 * zone for these events. The drag-START events (mousedown/up, touchstart/end)
 * stay patched, so a drag still ticks CD when it begins. If a hover/drag visual
 * ever stops updating, give that handler a signal or markForCheck (don't re-patch).
 */
(window as unknown as Record<string, unknown>)['__zone_symbol__UNPATCHED_EVENTS'] = ['wheel', 'mousewheel', 'mousemove', 'touchmove'];
